export class PackagesList {
    idList: string[];
    checkedId: string;
  
    constructor(idList: string[], checkedId: string) {
      this.idList = idList;
      this.checkedId = checkedId;
    }
  
    containCheckedId(): boolean {
      return this.idList.findIndex((checkedId) => checkedId === this.checkedId) > -1;
    }
  
    getListWithoutCheckedId(): string[] {
      return [...this.idList.filter((checkedId) => checkedId !== this.checkedId)];
    }
  
    getListWithCheckedId(): string[] {
      return [...this.idList, this.checkedId];
    }
  }